import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Media from 'react-media';
import Loading from 'pages/views/generic/Loading';
import { entities } from 'pages/store/schema';
import { getValues, getProcessing } from 'pages/store/selectors';
import { getData } from 'pages/store/actions/data';
import { actionTypes } from 'pages/store/actions/defaults';
import { breakpoints } from 'pages/utils/media';
import Header from './components/Header';
import Tabs from './components/Tabs';
import StepLoading from './components/StepLoading';
import ShopDetails from './forms/ShopDetails';
import TaxSettings from './forms/TaxSettings';
import { getGooglePlacesToken } from './utils';

class FirstStart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstStartStatus: null,
      currentStep: 1,
    };
  }

  componentDidMount() {
    try {
      const fjs = document.getElementsByTagName('script')[0];
      const js = document.createElement('script');
      js.src = `//maps.googleapis.com/maps/api/js?key=${getGooglePlacesToken()}&libraries=places`;
      js.async = false;
      fjs.parentNode.insertBefore(js, fjs);
    } catch (e) {
      // jest fails here without try/catch
    }

    window.lsCloud.Options.get('first_start_status').done(firstStartStatus => {
      if (firstStartStatus !== 'setup') {
        window.location.href = '/?form_name=ui_tab&tab=register';
      } else {
        this.setState({
          firstStartStatus,
        });

        this.getShopDetails();
      }
    });
  }

  getShopDetails() {
    this.props.getShopDetailsData('/admin/first_start/shop_setup');
  }

  getTaxSettings() {
    this.props.getTaxSettingsData('/admin/first_start/tax_setup');
  }

  handleStepChange(step) {
    if (step === 1) {
      this.getShopDetails();
    } else if (step === 2) {
      this.getTaxSettings();
    }

    this.setState(() => ({ currentStep: step }));
  }

  render() {
    const { isLoading, shopDetails, taxSettings } = this.props;
    const { currentStep, firstStartStatus } = this.state;

    return (
      <Fragment>
        {!firstStartStatus ? (
          <Loading />
        ) : (
          <div className="cr-max-width-content cr-display-block-centered">
            <Header />
            <Media query={{ minWidth: breakpoints.md }}>
              {matches => (
                <div
                  className={`cr-card ${!matches ? '' : 'cr-mh-4 cr-mb-4'}`}
                  style={{
                    borderRadius: !matches ? '0' : '',
                    borderLeftWidth: !matches ? '0' : '',
                    borderRightWidth: !matches ? '0' : '',
                  }}
                >
                  {!isLoading && (
                    <Tabs
                      tabs={[{ name: 'Location details' }, { name: 'Tax settings' }]}
                      currentStep={currentStep}
                      setStep={step => this.handleStepChange(step)}
                    />
                  )}
                  {isLoading ? (
                    <StepLoading />
                  ) : (
                    <Fragment>
                      {currentStep === 1 && (
                        <ShopDetails
                          data={shopDetails}
                          setStep={() => this.handleStepChange(currentStep + 1)}
                        />
                      )}
                      {currentStep === 2 && <TaxSettings data={taxSettings} />}
                    </Fragment>
                  )}
                </div>
              )}
            </Media>
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: !!(
    getProcessing({ entity: entities.shopDetails, list: false, actionType: actionTypes.LOADING })(
      state
    ) ||
    getProcessing({ entity: entities.taxSettings, list: false, actionType: actionTypes.LOADING })(
      state
    )
  ),
  shopDetails: getValues(entities.shopDetails)(state).shopSetup,
  taxSettings: getValues(entities.taxSettings)(state).taxSetup,
});

const mapDispatchToProps = dispatch => ({
  getShopDetailsData: (url, options, onSuccess) =>
    dispatch(getData({ url, entity: entities.shopDetails, list: false, options, onSuccess })),
  getTaxSettingsData: (url, options, onSuccess) =>
    dispatch(getData({ url, entity: entities.taxSettings, list: false, options, onSuccess })),
});

export default connect(mapStateToProps, mapDispatchToProps)(FirstStart);
